import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {ImgTagBasedImageComponent} from "./img-tag-based-image.component";
import {CanvasBasedImageComponent} from "@webmate-web-core/shared/components/screenshot/canvas-based-image.component";
import {CanvasModule} from "@webmate-web-core/shared/components/canvas/canvas.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ImageComponent} from '@webmate-web-core/shared/components/screenshot/image.component';

@NgModule({
    declarations: [
        ImgTagBasedImageComponent,
        CanvasBasedImageComponent,
        ImageComponent,
    ],
    imports: [CommonModule, CanvasModule, FontAwesomeModule, ProgressSpinnerModule],
    exports: [
        ImageComponent
    ]
})
export class ScreenshotModule { }
